export default __webpack_public_path__ + "static/media/right_icon.fbf0ff7c.svg";